import { render, staticRenderFns } from "./PrimaryApp.vue?vue&type=template&id=d5585df4&"
import script from "./PrimaryApp.vue?vue&type=script&lang=js&"
export * from "./PrimaryApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports